// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_q3V","cls2":"ChatInterface-cls2_dii ChatInterface-cls1_q3V"};